import React from 'react';

const AccordionContext = React.createContext({
    isOpen: false,
    toggle: () => {}
});

export default AccordionContext;
